// SPDX-License-Identifier: AGPL-3.0-or-later
export interface MediaProxyOptions {
	width?: number;
	height?: number;
	format?: string;
	quality?: 'high' | 'low' | 'lossless';
	animated?: boolean;
}
function appendMediaProxyParams(url: URL, options: MediaProxyOptions): void {
	const {width, height, format, quality, animated} = options;
	if (format) {
		url.searchParams.append('format', format);
	}
	if (width !== undefined) {
		url.searchParams.append('width', width.toString());
	}
	if (height !== undefined) {
		url.searchParams.append('height', height.toString());
	}
	if (quality) {
		url.searchParams.append('quality', quality);
	}
	if (animated !== undefined) {
		url.searchParams.append('animated', animated.toString());
	}
}
export function buildMediaProxyURL(originalUrl: string, options: MediaProxyOptions = {}): string {
	if (!originalUrl) return originalUrl;
	const url = new URL(originalUrl);
	appendMediaProxyParams(url, options);
	return url.toString();
}
export function stripMediaProxyParams(proxyURL: string): string {
	const url = new URL(proxyURL);
	url.searchParams.delete('width');
	url.searchParams.delete('height');
	url.searchParams.delete('format');
	url.searchParams.delete('quality');
	url.searchParams.delete('animated');
	return url.toString();
}
